
import bigPhotoBox from "../../assets/images/svg/graph-01.svg";
import smallPhotoBox from "../../assets/images/svg/graph-02.svg";

const NewProject = () => {
    return(
        <div className="new-project">
            <div className="container">
                <div className="d-flex justify-content-between flex-wrap">
                    <div className="data-box wow fadeInRight">
                        <h2 className="title">أنشئ جدوى مشروعك</h2>
                        <p>اداة إقتصادية لتسهيل عملية دراسة الجدوى للمشاريع و التخطيط لها</p><a className="main-btn" href="/home/start">ابدأ الآن</a>
                    </div>
                    <div className="photo-box wow fadeInLeft" data-wow-delay="0.25s">
                        <div className="big-photo-box">
                          <h3 className="photo-title">عنوان عنوان</h3><img className="img-fluid" src={bigPhotoBox} alt="chart"/>
                        </div>
                        <div className="small-photo-box">
                            <h3 className="photo-title">عنوان عنوان</h3><img className="img-fluid"  src={smallPhotoBox} alt="chart"/>
                        </div>
    
                    </div>
                </div>
            </div>
        </div>   
    );

};
export default NewProject;
